import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export function TextEditor({ value = '', onChange }) {
  return <ReactQuill theme='snow' value={value} onChange={onChange} />;
}
